var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("status-template", {
    attrs: {
      title: _vm.$t("title"),
      imageUrl: require(`@/assets/kyc/step_qr_code_1.svg`).default,
    },
    scopedSlots: _vm._u([
      {
        key: "description",
        fn: function () {
          return [
            _c("jade-text", { attrs: { variant: "text-medium" } }, [
              _vm._v(" " + _vm._s(_vm.$t("description-1")) + " "),
              _c("b", [_vm._v(_vm._s(_vm.$t("description-2")))]),
              _vm._v(" " + _vm._s(_vm.$t("description-3")) + " "),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "trailing",
        fn: function () {
          return [
            _vm.error
              ? _c(
                  "jade-alert",
                  {
                    staticClass: "alert",
                    attrs: { variant: "negative", "show-icon": "" },
                  },
                  [
                    _c("jade-text", { attrs: { color: "negative" } }, [
                      _vm._v(" " + _vm._s(_vm.$t("error-alert")) + " "),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
            _c("generate-link-button", {
              attrs: { id: _vm.id },
              on: {
                error: _vm.handleGenerateLinkError,
                generating: _vm.handleGenerating,
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }